import { Receipt } from 'lucide-react'

interface OrderDetailsRequestProps {
  interactiveData: any
}

export function OrderDetailsRequest({ interactiveData }: OrderDetailsRequestProps) {
  const params = interactiveData.action?.parameters || {}
  const order = params.order || {}
  const items: any[] = order.items || []
  const referenceId: string = params.reference_id || ''
  const bodyText: string = interactiveData.body?.text || 'Your order is ready for payment'
  const currency: string = params.currency || 'INR'

  const toAmount = (amt: any) => {
    if (!amt || typeof amt.value !== 'number') return null
    const offset = amt.offset || 100
    return amt.value / offset
  }

  const totalAmount = toAmount(params.total_amount)

  return (
    <div className="max-w-sm min-w-0" style={{ fontFamily: 'var(--wn-font)' }} data-testid="inbox-order-details-card">
      <div className="flex items-center gap-2.5 pb-2.5 border-b border-[#edf1f7]">
        <div
          className="h-9 w-9 rounded-[10px] flex items-center justify-center shrink-0"
          style={{ background: '#E8F8F0' }}
        >
          <Receipt className="h-4 w-4" style={{ color: '#1EB677' }} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="truncate" style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 700, color: '#101828' }}>
            Order Request
          </div>
          {referenceId && (
            <div className="truncate mt-0.5" style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}>
              #{referenceId}
            </div>
          )}
        </div>
      </div>

      {bodyText && (
        <div
          className="mt-2.5 break-words whitespace-pre-wrap"
          style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 500, color: '#101828' }}
        >
          {bodyText}
        </div>
      )}

      {items.length > 0 && (
        <div className="mt-2.5 space-y-1.5">
          <div
            className="rounded-[10px] p-2.5 space-y-1.5"
            style={{ background: '#fbfcfd', border: '1px solid #edf1f7' }}
          >
            {items.map((item: any, index: number) => {
              const itemAmount = toAmount(item.amount)
              return (
                <div
                  key={index}
                  className="flex justify-between items-start gap-2 pb-1.5 border-b border-[#edf1f7] last:border-b-0 last:pb-0"
                >
                  <div className="flex-1 min-w-0">
                    <div className="truncate" style={{ fontFamily: 'var(--wn-font)', fontSize: 12, fontWeight: 600, color: '#101828' }}>
                      {item.name || 'Item'}
                    </div>
                    <div style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}>
                      Quantity {item.quantity || 1}
                    </div>
                  </div>
                  {itemAmount !== null && (
                    <div className="shrink-0" style={{ fontFamily: 'var(--wn-font)', fontSize: 12, fontWeight: 700, color: '#101828' }}>
                      {currency === 'INR' ? '₹' : `${currency} `}{itemAmount.toFixed(2)}
                    </div>
                  )}
                </div>
              )
            })}

            {totalAmount !== null && (
              <div className="flex justify-between items-center pt-2 mt-1 border-t border-[#edf1f7]">
                <div style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 700, color: '#101828' }}>
                  Total
                </div>
                <div style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 700, color: '#1EB677' }}>
                  {currency === 'INR' ? '₹' : `${currency} `}{totalAmount.toFixed(2)}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {interactiveData.footer?.text && (
        <div className="mt-2 break-words" style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}>
          {interactiveData.footer.text}
        </div>
      )}

      <div className="mt-3 pt-2.5 border-t border-[#edf1f7] space-y-1.5">
        <button
          type="button"
          disabled
          className="w-full rounded-[8px] py-2 px-4 text-center cursor-default"
          style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 600, color: '#1EB677', background: 'transparent' }}
        >
          Review and pay
        </button>
        <button
          type="button"
          disabled
          className="w-full rounded-[8px] py-2 px-4 text-center cursor-default"
          style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 600, color: '#1EB677', background: 'transparent' }}
        >
          Pay now
        </button>
      </div>
    </div>
  )
}
